<template>
    <div id="role-integration">
        <!-- inicio de sesión -->
        <vs-popup class="header-primary" :active.sync="showEmailMatchPopup" title="Tu cuenta ya existe">
            <div class="p-6">
                <p class="mb-4 black">Ya existe tu cuenta con este correo. Solo debes iniciar sesión.</p>

                <vs-button class="mb-4" @click="showEmailMatchPopup = false, goToLogin()">Ir a iniciar
                    sesión</vs-button>
                <p class="black">¿Olvidaste tu contraseña? <span
                        @click="showEmailMatchPopup = false, gotoPasswordReset()" class="clickable-img"><b><u>Da clic
                                aquí</u></b></span></p>
            </div>
        </vs-popup>

        <!-- creación de nueva cuenta -->
        <vs-popup class="header-primary" :active.sync="showNewAccountEmail" title="Ya eres usuario en RedGirasol">
            <div class="p-6">
                <p class="mb-base black">
                    Tu usuario ya existe en <u>RedGirasol</u>. <br><br>

                    Enviaremos un código al correo <b>{{ onboardingUserData.email }}</b> para confirmar que eres tú y
                    crear tu cuenta de <b>{{ role }}</b>.
                </p>

                <vs-button @click="requestVerificationCode(true)">Continuar</vs-button>
                <vs-popup class="header-primary" :active.sync="showEmailVerificationCodePopup"
                    title="Confirma que eres tú">
                    <div class="p-6">
                        <p class="mb-4 black">
                            Ingresa los 6 dígitos del código que enviamos por correo a <b>{{ onboardingUserData.email
                            }}</b>.
                        </p>
                        <vs-input type="text" name="email-code" class="mb-4" maxlength="6" v-model="codeEmail"
                            @input="onCodeInput" :danger="codeEmail.length > 0 && codeEmail.length !== 6"
                            danger-text="Debe tener exactamente 6 números"></vs-input>
                        <p class="black mb-base">¿No lo recibiste?
                            <span v-if="resendTimer > 0">
                                Reenviar en
                                <b>{{ resendTimer }}s</b>
                            </span>
                            <span @click.stop="requestVerificationCode()" class="clickable-img" v-else>
                                <u>Reenviar</u>
                            </span>
                        </p>
                        <vs-button :disabled="!isValidCode()" @click.stop="requestNewAccount()"
                            color="primary">Continuar</vs-button>
                    </div>
                </vs-popup>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {
    data: () => ({
        isMounted: false,
        showEmailMatchPopup: false,
        showNewAccountEmail: false,
        showEmailVerificationCodePopup: false,
        codeEmail: "",
        resendTimer: 45,
        resendEnaled: false,
        timer: null,
        matchedRole: null
    }),
    props: {
        onboardingUserData: Object,
        role: String
    },
    async beforeMount() {
        this.setUpTimerConfig();
        this.isMounted = true;
    },
    methods: {
        startEmailMatchFlow(emailData) {
            if (emailData == null) return;

            // Sí es solicitante el rol que ya tiene, se sugiere iniciar sesión
            const matchRole = emailData.user_roles.includes(this.role);
            this.matchedRole = emailData.user_roles[0];


            // Sí la cuenta coincide con el rol, se invita a hacer login
            if (matchRole) {
                this.showEmailMatchPopup = true;
            } else {
                // Sí no coincide, se envía para generar una nueva cuenta con este nuevo rol.
                this.showNewAccountEmail = true;
            }


        },
        onCodeInput() {
            // deja solo números
            this.codeEmail = (this.codeEmail || '').replace(/\D/g, '').slice(0, 6)
        },
        isValidCode() {
            return /^\d{6}$/.test(this.codeEmail)
        },
        setUpTimerConfig() {
            window.clearInterval(this.timer);
            this.resendEnabled = false;
            this.resendTimer = 45;

            this.$nextTick(() => {
                this.initNipCounter();
            });
        },
        initNipCounter() {
            window.clearInterval(this.timer);

            this.timer = setInterval(() => {
                if (this.resendTimer > 0) {
                    this.resendTimer--;
                }

                if (this.resendTimer <= 0) {
                    window.clearInterval(this.timer);
                    this.timer = null;
                    this.resendEnabled = true;
                }
            }, 1000);
        },
        async requestVerificationCode(isResending = false) {
            try {

                const res = await this.publicApiPost("/api/auth/user/role-integration/verification-code", {
                    email: this.onboardingUserData.email
                });

                if (res.data.is_valid) {
                    if (isResending) {
                        this.showEmailVerificationCodePopup = true;
                    }
                    this.setUpTimerConfig();
                } else {
                    this.errorNotif("Error en la operación.")
                }

            } catch (error) {
                this.showLoading(false);
                this.showError(error);
            } finally {
                this.showLoading(false);
            }
        },
        async requestNewAccount() {
            try {
                this.showLoading(true, "Generando cuenta...");
                const res = await this.publicApiPost("/api/auth/user/role-integration/create-account", {
                    email: this.onboardingUserData.email,
                    code: this.codeEmail,
                    role_to_add: this.role,
                    role_matched: this.matchedRole
                });
                this.showLoading(false);

                const status = res.data.success;

                if (status) {
                    // Manda a hacer login
                    this.successNotif("Cuenta creada exitosamente", `Hemos confirmado tu correo y creado tu cuenta de ${this.role}.`);
                    this.showEmailVerificationCodePopup = false;
                    this.showNewAccountEmail = false;
                    await this.$emit("onsuccess", this.codeEmail);

                } else {
                    this.errorNotif("Error en la operación.", res.data.error);
                    await this.goToLogin();
                }
            } catch (error) {
                console.error(error);
                this.showLoading(false);
            } finally {
                this.showLoading(false);
            }
        },
        async goToLogin() {
            await this.$router.replace({ name: 'login' });
        },
        async gotoPasswordReset() {
            await this.$router.push({name: 'recuperarPassword'});
        },
    }
}
</script>

<style>

#role-integration {
    position: absolute;
}

</style>